export type PrevoyanceLandingProduct = "deces" | "dependance" | "obseques" | "gav" | "vie" | "chomage"

export interface PrevoyanceProduct {
    key: PrevoyanceLandingProduct
    name: string
    tagline: string
    lead: string
    description: string
    icon: string
    url: string
}

export const PREVOYANCE_PRODUCTS: PrevoyanceProduct[] = [
    {
        key: "deces",
        name: "Assurance décès",
        tagline: "Un capital ou une rente pour vos proches",
        lead: "Sécurisez l'avenir financier de vos proches en cas de décès prématuré.",
        description: "Cette assurance fournit un capital ou une rente à vos bénéficiaires, les aidant à maintenir leur niveau de vie malgré la perte de revenus.",
        icon: "fa-cross",
        url: "/guide/assurance-deces",
    },
    {
        key: "dependance",
        name: "Assurance dépendance",
        tagline: "Une aide en cas de perte d'autonomie",
        lead: "Prévoyez une assistance financière en cas de perte d'autonomie.",
        description: "Cette assurance vous aide à couvrir les coûts des soins et services nécessaires lorsque vous ne pouvez plus réaliser seul les actes de la vie quotidienne.",
        icon: "fa-family",
        url: "/guide/assurance-dependance",
    },
    {
        key: "obseques",
        name: "Assurance obsèques",
        tagline: "Financer et organiser vos obsèques",
        lead: "Anticipez l'organisation et le financement de vos obsèques.",
        description: "Ce produit assure le paiement d'une somme à un prestataire désigné pour couvrir les frais liés à vos obsèques, soulageant vos proches des préoccupations financières et organisationnelles.",
        icon: "fa-tombstone",
        url: "/guide/assurance-obseques",
    },
    {
        key: "gav",
        name: "Garantie accidents de la vie",
        tagline: "Accidents domestiques, scolaires, loisirs",
        lead: "Protégez-vous contre les conséquences financières des accidents domestiques, scolaires ou de loisirs.",
        description: "Cette garantie offre une compensation en cas d'invalidité permanente et prend en charge les frais médicaux.",
        icon: "fa-bone-break",
        url: "/guide/assurance-garantie-accidents-vie",
    },
    {
        key: "vie",
        name: "Assurance vie",
        tagline: "Épargner et transmettre un capital",
        lead: "Faites fructifier votre épargne et préparez la transmission de votre patrimoine.",
        description: "L'assurance vie permet de constituer un capital, de compléter vos revenus à la retraite et de le transmettre à vos bénéficiaires dans un cadre fiscal avantageux.",
        icon: "fa-shield-check",
        url: "/guide/assurance-vie",
    },
    {
        key: "chomage",
        name: "Accidents chômage",
        tagline: "Vos revenus protégés en cas de coup dur",
        lead: "Maintenez vos revenus en cas d'arrêt de travail suite à un accident ou de perte d'emploi.",
        description: "Cette garantie verse une indemnité pour vous aider à faire face à vos charges courantes le temps de retrouver une activité.",
        icon: "fa-briefcase",
        url: "/guide/assurance-chomage",
    },
]
